import { useState, useEffect } from "react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

const Textbox = ({ itemkey, content, onChange, defaultValue }) => {
  const [value, setValue] = useState("");

  const handleValueChange = (e) => {
    if (onChange) {
      setValue(e.target.value);
      onChange(content.key, e.target.value);
    } else {
      setValue(defaultValue || "");
    }
  };

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <div className="mt-3 text-start">
      <Label className="font-semibold text-gray-800 text-sm mb-1.5 block">
        {content.label}
      </Label>
      <Input
        type="text"
        size="50"
        value={value}
        onChange={handleValueChange}
        className="block w-full text-base rounded-lg border border-gray-200 bg-white px-3.5 py-3 text-gray-900 placeholder:text-gray-400 hover:border-gray-300 focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:ring-offset-0 transition-all duration-150 shadow-sm outline-none"
      />
    </div>
  );
};

export default Textbox;
